define('MM/Components/ClientPortal/GatedModalCompleteTracker',['eventManager'], function (eventManager) {

    function GatedModalCompleteTracker(scope, modeValue, modeSignInName, modeSignUpName) {

        if (modeValue == modeSignInName) {
            eventManager.trigger('gated_modal', 'complete_sign_in');
        } else if (modeValue == modeSignUpName)
        {
            eventManager.trigger('gated_modal', 'complete_sign_up');
        }
    }

    GatedModalCompleteTracker.init = function init(args) {
        if (args.IsExperienceEditorEditing === !0) return null;

        return new GatedModalCompleteTracker(args.scope, args.ModeValue, args.ModeSignInName, args.ModeSignUpName);
    }

    return GatedModalCompleteTracker;
});
